export const shouldHideDate = (postLink: string) =>
  !postLink.match(/^(\/item|\/allshows)/)
